import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
import { DataTableCustomized } from '@/components/ui/data-table-customized'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'
import { getInvoiceTransactions } from '@/modules/Invoice/services'
import { getTransactionColumns } from './columns'

interface ListProps {
    invoiceID: number
}

const List: React.FC<ListProps> = ({ invoiceID }) => {
    const { t } = useTranslation()

    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.INVOICE_TRANSACTIONS, invoiceID],
        queryFn: () => getInvoiceTransactions({ invoiceID }),
    })

    const rows = data?.results || []
    const columns = useMemo(() => getTransactionColumns(t), [t])

    const stateComponent = renderState()
    if (stateComponent) return stateComponent

    return (
        <div className="bg-white rounded-md p-4 space-y-2">
            <Typogaphy className="text-primary font-medium capitalize">
                {t('transactions')}
            </Typogaphy>
            <DataTableCustomized
                columns={columns}
                rows={rows}
                rowKey={(row) => row.invoice_transaction_id}
            />
        </div>
    )
}

export default List
